import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var UploadCloudIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M23.328 11.1C22.272 9.2 20.352 8 18.24 8h-.576c-1.44-4.4-5.856-6.9-10.272-5.7-2.208.6-4.128 2.1-5.28 4.1-1.152 2.1-1.536 4.5-.96 6.8.384 1.5 1.056 2.8 2.016 3.8.384.4.96.4 1.344 0 .384-.4.384-1 0-1.4-.672-.7-1.248-1.7-1.44-2.8-.48-1.9-.192-3.7.672-5.3.96-1.6 2.4-2.7 4.128-3.2 3.648-1 7.2 1.2 8.16 5 .096.4.48.8.96.8h1.248c1.44 0 2.688.8 3.36 2.1.96 1.9.288 4.4-1.536 5.4-.48.3-.672.9-.384 1.4.192.3.48.5.864.5.192 0 .288 0 .48-.1 2.688-1.7 3.744-5.4 2.304-8.3zm-10.176.2c-.096-.1-.192-.2-.288-.2-.192-.1-.48-.1-.768 0-.096.1-.192.1-.288.2l-3.84 4c-.384.4-.384 1 0 1.4.384.4.96.4 1.344 0l2.208-2.3V21c0 .6.384 1 .96 1s.96-.4.96-1v-6.6l2.208 2.3c.192.2.48.3.672.3.192 0 .48-.1.672-.3.384-.4.384-1 0-1.4l-3.84-4z"
                        }),
                        _jsxs("g", {
                            fillRule: "evenodd",
                            children: [
                                _jsx("use", {}),
                                _jsx("use", {
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
UploadCloudIcon.isCarinaIcon = true;
export default UploadCloudIcon;
